import classNames from "classnames";
import { VismaInputNode } from "../../build/types";
import { BuilderVismaInputProps } from "../BuilderInterface";
import { getCompoundStyle } from "../helpers";

const BuilderVismaInput = ({ node, builderProps, value, inputCallback }: BuilderVismaInputProps) => {
    const vINode = node as VismaInputNode;
    const { attr } = node;

    const buildSearchClass = classNames("builder-visma-input", {
        [`${attr?.className}`]: !!attr?.className,
        ["search-active"]: value,
        ["builder-mode"]: !!builderProps
    });

    if (builderProps) {
        return (
            <div
                {...attr}
                className={buildSearchClass}
                style={getCompoundStyle({ node })}
                onClick={e => (builderProps?.selectCallback ? builderProps.selectCallback(e, node.id) : {})}
                onMouseMove={e => (builderProps?.outlineCallback ? builderProps.outlineCallback(e, node.id) : {})}
                id={node.id}
                onDragStart={e => builderProps.onDragStart?.(e, node.id)}
                draggable={"true"}
                onDragEnd={builderProps.onDragEnd}
            >
                <div className="input-row">
                    <input
                        type="text"
                        placeholder={vINode.input?.placeholder}
                        readOnly
                        value={builderProps?.active ? "395275" : ""}
                        style={vINode.input?.style}
                    />
                </div>
            </div>
        );
    } else {
        return (
            <div {...attr} className={buildSearchClass} style={getCompoundStyle({ node })}>
                <div className="input-row" style={vINode.input?.style}>
                    <input
                        type="text"
                        placeholder={vINode.input?.placeholder}
                        value={value}
                        onInput={e => inputCallback?.(e.currentTarget.value)}
                        style={vINode.input?.style}
                    />
                </div>
            </div>
        );
    }
};

export default BuilderVismaInput;
